// Light/dark theme. The choice is stored under "theme"; with no stored choice the device preference is used.
// public/index.html applies the same logic before first paint.
export const THEME_KEY = "theme";

export const getStoredTheme = () => {
  try {
    const value = localStorage.getItem(THEME_KEY);
    return value === "light" || value === "dark" ? value : null;
  } catch (e) {
    return null;
  }
};

export const systemTheme = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";

export const resolveTheme = () => getStoredTheme() || systemTheme();

export const applyTheme = (theme) => {
  const root = document.documentElement;
  root.classList.toggle("dark", theme === "dark");
  root.setAttribute("data-theme", theme);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", theme === "dark" ? "#0b111e" : "#1d6b4b");
};

export const storeTheme = (theme) => {
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch (e) {
    // private mode / blocked storage: the theme still applies for this visit
  }
};
